import React from 'react';
import { Box, Button, Card, CardBody, Table, Tbody, Tr, Th, Td, Text } from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';
import { formatCurrency } from '../global/data/formatCurrencyHelper';
import moment from 'moment';

import { Transaction } from '../../store/page/types';
import TransactionStatusBadge from '../page/TransactionStatusBadge';
import { UserTransactionsDetails, User } from '../../store/user/types';
import NoContentPage from '../../pages/noContent/NoContentPage';
import TransactionRow from '../page/TransactionRow';

interface ViewUserTransactionsProps {
  userView: string;
  userTransactions: Transaction[];
  userTransactionsDetails: UserTransactionsDetails;
  user: User | null;
  fetchUserTransactions: (userId: string, more: boolean) => void;
}

const ViewUserTransactions: React.FC<ViewUserTransactionsProps> = ({ userView, userTransactions, user, userTransactionsDetails, fetchUserTransactions }) => {
  if (userView!=='transactions') {
    return null;
  }

  const renderMoreButton = () => {
    const { currentPage, totalPages } = userTransactionsDetails;
    if (currentPage && totalPages && currentPage < totalPages) {
      return (
        <Box display="flex" justifyContent="center" mt={2}>
          <Button size='xs' leftIcon={<ViewIcon />} onClick={
            () => {
              if (user && user._id) {
                fetchUserTransactions(user._id, true)
              }
            }
            }>More</Button>
        </Box>
      )
    }
    return null;
  }

  return (
    <Box paddingTop={5} paddingBottom={5}>
      <Card borderRadius={20}>
        <CardBody>
          <Table>
            <Tbody>
              <Tr>
                <Th>Identifier</Th>
                <Th>Timestamp</Th>
                <Th>Type</Th>
                <Th textAlign={'right'}>Amount</Th>
                <Th>Method</Th>
                <Th>Status</Th>
              </Tr>
              {userTransactions.map((item: Transaction, index: number) => {
                let data = {}
                if (item.data) {
                  data = {...item.data}
                }
                return <TransactionRow transaction={{...item, data}} key={index} />
                })}
            </Tbody>
          </Table> 
          {renderMoreButton()}    
          { !userTransactions.length && (
            <NoContentPage noContentText='No Transactions Found' />
          )}               
        </CardBody>
      </Card>  
    </Box>      
  );
}

export default ViewUserTransactions;
